export default __webpack_public_path__ + "static/protester-9d8d8dafee58e54d8a4b90098a43e050.svg";